const _paq = window._paq || [];
window._paq = _paq;

_paq.push(['trackPageView']);
_paq.push(['enableLinkTracking']);

const tracker = (url, siteId) => {
	const u = url;
	_paq.push(['setTrackerUrl', u+'piwik.php']);
	_paq.push(['setSiteId', siteId]);
			
	var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
	g.type='text/javascript'; g.async=true; g.defer=true; g.src=u+'piwik.js'; s.parentNode.insertBefore(g,s);
};

export default tracker;